export const VERALLIA_MONITORING_CONFIG = {
  clientId: 'verallia',
  bucket: 'health_checker',
  staleAfterSeconds: 120,
  timelineBucketMinutes: 30,
  lastSeenLookback: '-365d',
  diskLookback: '-24h',
  refreshIntervalMs: 60000,
  aiMonitoring: {
    enabled: true,
    bucket: 'health_checker',
    measurement: 'engine_health',
    field: 'is_running',
    staleAfterSeconds: 60,
    lastRunLookback: '-30d',
  },
  devices: [
    { id: '192.168.1.254', name: 'Rack 1' },
    { id: '192.168.1.15', name: 'Rack 1 - Screen' },
    { id: '192.168.1.20', name: 'Rack 1 - Camera 1', aiMonitoring: true },
    { id: '192.168.1.21', name: 'Rack 1 - Camera 2', aiMonitoring: true },
    { id: '192.168.1.22', name: 'Rack 1 - Camera 3', aiMonitoring: true },
    { id: '192.168.1.23', name: 'Rack 1 - Camera 4', aiMonitoring: true },
    { id: '192.168.1.24', name: 'Rack 1 - Camera 5', aiMonitoring: true },
    { id: '192.168.1.10', name: 'Rack 1 - Red warning light' },
    { id: '192.168.2.254', name: 'Rack 2' },
    { id: '192.168.2.20', name: 'Rack 2 - Camera 1', aiMonitoring: true },
    { id: '192.168.2.21', name: 'Rack 2 - Camera 2', aiMonitoring: true },
    { id: '192.168.2.22', name: 'Rack 2 - Camera 3', aiMonitoring: true },
    { id: '192.168.2.23', name: 'Rack 2 - Camera 4', aiMonitoring: true },
    { id: '192.168.2.24', name: 'Rack 2 - Camera 5', aiMonitoring: true },
    { id: '192.168.2.25', name: 'Rack 2 - Camera 6', aiMonitoring: true },
    { id: '192.168.2.10', name: 'Rack 2 - Red warning light' },
    { id: '192.168.3.254', name: 'Rack 3' },
    { id: '192.168.3.15', name: 'Rack 3 - Screen' },
    { id: '192.168.3.20', name: 'Rack 3 - Camera 1', aiMonitoring: true },
    { id: '192.168.3.21', name: 'Rack 3 - Camera 2', aiMonitoring: true },
    { id: '192.168.3.22', name: 'Rack 3 - Camera 3', aiMonitoring: true },
    { id: '192.168.3.23', name: 'Rack 3 - Camera 4', aiMonitoring: true },
    { id: '192.168.3.24', name: 'Rack 3 - Camera 5', aiMonitoring: true },
    { id: '192.168.3.10', name: 'Rack 3 - Red warning light' },
  ],
};
